<template>
    <div class="log-wrapper">
      <TableWithPagination
        tableBorder="default"
        :columnList="columnList"
        :tableData="targetLists"
        :sortInfo.sync="sortInfo"
        :pagination.sync="pagination"
        @size-change="getTargetLists"
        @current-change="getTargetLists"
        @sort-change="getTargetLists"
      />
    </div>
  </template>

<script>
import * as dayjs from 'dayjs';
import TableWithPagination, { TablePaginationMixin } from '@/components/common/TableWithPagination';
import { queryBizOppDynamicInfoPageList } from '@/api/businessOpportunity.js';

export default {
  props: {
    id: {
      type: [Number, String],
      default: '',
    },
  },
  components: {
    TableWithPagination,
  },
  mixins: [TablePaginationMixin],
  computed: {
    columnList () {
      let ret = [
        {
          tooltip: true,
          label: '时间',
          minWidth: '',
          width: '140px',
          prop: 'createTime',
          format: (v) => {
            return this.formatTime(v);
          },
        },
        {
          tooltip: true,
          label: '操作人',
          minWidth: '',
          width: '160px',
          prop: 'createUserName',
        },
        {
          tooltip: true,
          label: '事项类型',
          minWidth: '',
          width: '120px',
          prop: 'actionDesc',
        },
        {
          tooltip: true,
          label: '事项描述',
          minWidth: '200px',
          width: '',
          prop: 'content',
        },
      ];

      return ret;
    },
  },
  data () {
    return {
      targetLists: [],
    };
  },
  methods: {
    formatTime (v) {
      let ret = '';

      if (v) {
        ret = dayjs(v * 1).format('YYYY-MM-DD HH:mm');
      }

      return ret;
    },
    init () {
      this.targetLists = [];
      this.pageNum = 1;

      this.getTargetLists();
    },
    async getTargetLists () {
      const params = {
        module: 'INQUIRE_PRICE',
        businessId: this.id,
        pageNum: this.pagination.currentPage,
        pageSize: this.pagination.pageSize,
      };
      if (this.sortInfo.orderByProperty && this.sortInfo.orderByType) {
        params.orderBy = [this.sortInfo];
      }
      const { body } = await queryBizOppDynamicInfoPageList(params);

      this.targetLists = body?.list || [];

      this.pagination.total = Number(body?.total || 0);
    },
  },
  mounted () {
    this.init();
  },
};
</script>
  <style lang="scss" scoped>
  .log-wrapper {
    background-color: #fff;
    padding: 8px;

    /deep/ .ant-table-thead {
      &>tr>th {
        padding: 9px 16px;
        font-weight: bold;
        background-color: #F2F4F7;
      }
    }

    /deep/ .ant-table-tbody {
      tr {
        background-color: #fff;

        &>td {
          padding: 9px 16px;
        }
      }
    }
  }
  </style>
